module.exports = __webpack_public_path__ + "static/media/relatorio.d8936e0b.svg";